import React from 'react'
// import { useState,useEffect } from 'react'

export default function PokemonInfo({ data }) {
  // console.log(data)

  return (

    <>
      {
        (!data) ? "" : (
          <>
            <h1>{data.name}</h1>
            <img src={`https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${data.id}.svg`} alt="charmender" />

            <div className="abilities">

              {


                data.abilities.map(poke => {
                  return (
                    <>
                      <div className="group">
                        <h2>{poke.ability.name}</h2>
                      </div>
                    </>
                  )
                })
              }

            </div>

            <div className="base-stats">

              {

                data.stats.map(poke => {
                  return (
                    <>

                      <h3 className='font-extrabold text-2xl'>{poke.stat.name}  : {poke.base_stat}</h3>


                    </>


                  )
                })
              }
            </div>
          </>
        )
      }


    </>
  )
}

